var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.21588L1.72727 5.94316C6.01955 1.65088 12.9805 1.65088 17.2727 5.94316L19 4.21588C13.7577 -1.02639 5.25091 -1.02639 0 4.21588ZM6.90909 11.125L9.5 13.7159L12.0909 11.125C10.6659 9.69134 8.34273 9.69134 6.90909 11.125ZM3.45455 7.67043L5.18182 9.3977C7.56545 7.01407 11.4345 7.01407 13.8182 9.3977L15.5455 7.67043C12.2118 4.33679 6.79682 4.33679 3.45455 7.67043Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.d03e76fa2b2a3941057f63e8efeb1653.svg";
export { ForwardRef as ReactComponent };